import './Header.css'

import React from 'react'

import { UserMenu } from '../../../auth/UserMenu'
import { LanguageSelection } from './LanguageSelection'
import { Logo } from './Logo'
import { MicroAppSelection } from './MicroAppSelection/MicroAppSelection'
import { ThemeCss } from './ThemeCss'
import { Title } from './Title'
import { UserGuide } from './UserGuide'

export const Header: React.FC = () => {
  return (
    <>
      <ThemeCss />

      <header className="header flex justify-content-between align-items-center pl-6 pr-2 lg:px-2 h-3rem">
        <Logo />

        <Title />

        <div className="flex align-items-center gap-2">
          <MicroAppSelection />
          <LanguageSelection />
          <UserGuide />
          <UserMenu />
        </div>
      </header>
    </>
  )
}
